// initial state
import { guest } from '../../plugin/axios'
export default{
 namespaced:true,

state:{
    models: [],
    model: null,
    loadMake: [],
    isLoading: false,
    isCreating: false,
    createdData: null,
    isUpdating: false,
    updatedData: null,
    isDeleting: false,
    deletedData: null,
},
mutations:{
    setModels: (state, models) => {
        state.models = models
    },
    setModelDetail: (state, model) => {
        state.model = model
    },
    saveNewModels: (state, model) => {
        // state.models.unshift(model)
        state.createdData = model
    },
    saveUpdatedModel: (state, model) => {
        // Find index
        // state.models.unshift(model)
        state.updatedData = model
        const index = state.models.findIndex(
            (model) => model.id === state.updatedData.id
        )
        if (index !== -1) {
            state.models.splice(index, 1, state.updatedData)
        }
    },
    setDeleteModel: (state, id) => {
        const index = state.models
            .map((x) => {
                return x.id
            })
            .indexOf(id)
        state.models.splice(index, 1)
    },
    setModelIsLoading(state, isLoading) {
        state.isLoading = isLoading
    },
    setModelIsCreating(state, isCreating) {
        state.isCreating = isCreating
    },
    setModelIsUpdating(state, isUpdating) {
        state.isUpdating = isUpdating
    },
    setModelIsDeleting(state, isDeleting) {
        state.isDeleting = isDeleting
    },
    setLoadMake: (state, loadMake) => {
        state.loadMake = loadMake
    },
},
actions:{
    async fetchAllModels({ commit }) {
        commit('setModelIsLoading', true)
        await guest
            .get('/models')
            .then((res) => {
                const models = res.data.model
                commit('setModels', models)
                commit('setModelIsLoading', false)
            })
            .catch((err) => {
                this.$toast.error(err)
                commit('setModelIsLoading', false)
            })
    },
    async storeModel({ commit }, model) {
        commit('setModelIsCreating', true)
        await guest
            .post('/models-store', model)
            .then((res) => {
                if (res.data.email) {
                    this.$toast.error(res.data.email[0])
                    commit('setModelIsCreating', false)
                } else {
                    commit('saveNewModels', res.data.model)
                    commit('setModelIsCreating', false)
                }
            })
            .catch((err) => {
                if (err.response.status === 422) {
                    commit('setModelIsCreating', false)
                    this.$toast.error('Field Not Properly Filled')
                }
            })
    },
    async fetchDetailModel({ commit }, id) {
        commit('setModelIsLoading', true)
        await guest
            .get(`models-show/${id}`)
            .then((res) => {
                commit('setModelDetail', res.data.model)
                commit('setModelIsLoading', false)
            })
            .catch((err) => {
                if (err.response.status === 422) {
                    this.$toast.error('Field Not Properly Field')
                    commit('setModelIsLoading', false)
                }
            })
    },
    async updateModel({ commit }, model) {
        commit('setModelIsUpdating', true)
        await guest
            .post(`models-update/${model.id}`, model)
            .then((res) => {
                commit('saveUpdatedModel', res.data.model)
                commit('setModelIsUpdating', false)
            })
            .catch((err) => {
                if (err.response.status === 422) {
                    this.$toast.error('Fields not properly filled')
                    commit('setModelIsUpdating', false)
                }
            })
    },
    async deleteModel({ commit }, id) {
        commit('setModelIsDeleting', true)
        await guest
            .delete(`models-delete/${id}`)
            .then((res) => {
                commit('setDeleteModel', res.data.model.id)
                commit('setModelIsDeleting', false)
            })
            .catch((err) => {
                if (err.response.status === 422) {
                    this.$toast.error('Field Not Properly Filled')
                    commit('setModelIsDeleting', false)
                }
            })
    },
    async fetchLoadModel({ commit }, id) {
        commit('setModelIsLoading', true)
        await guest
            .get(`models-show/${id}`)
            .then((res) => {
                commit('setLoadMake', res.data.model)
                commit('setModelIsLoading', false)
            })
            .catch((err) => {
                if (err.response.status === 422) {
                    this.$toast.error('Field Not Properly Field')
                    commit('setModelIsLoading', false)
                }
            })
    },
},
getters:{
    modelList: (state) => state.models,
    model: (state) => state.model,
    isLoadingModel: (state) => state.isLoading,
    isCreating: (state) => state.isCreating,
    isUpdating: (state) => state.isUpdating,
    createdData: (state) => state.createdData,
    updatedData: (state) => state.updatedData,
    isDeleting: (state) => state.isDeleting,
    deletedData: (state) => state.deletedData,
    modelBaseOnMakeList: (state) => state.loadMake,
}
}